import { render, staticRenderFns } from "./curriculum_schedule.vue?vue&type=template&id=0a3ad944&scoped=true&"
import script from "./curriculum_schedule.vue?vue&type=script&lang=js&"
export * from "./curriculum_schedule.vue?vue&type=script&lang=js&"
import style0 from "./curriculum_schedule.vue?vue&type=style&index=0&id=0a3ad944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ad944",
  null
  
)

export default component.exports